// extracted by mini-css-extract-plugin
export default {"orderTrackingCard":"OrderTracking_orderTrackingCard__g5+iV","numbers":"OrderTracking_numbers__eevqJ","box":"OrderTracking_box__G7Muu","active":"OrderTracking_active__vuhkz"};